import {BaseUser, generatePath, ONE_HOUR_IN_MS, ResponsiveImage} from '@legit.health/ui';
import useSuspenseApiQuery from '@/shared/hooks/useSuspenseApiQuery';

export default function QrImage({patient}: {patient: BaseUser}) {
  const qrQuery = useSuspenseApiQuery<{qr: string}>({
    queryOptions: {
      queryKey: ['upload-temporary-images-qr', patient.id],
      staleTime: ONE_HOUR_IN_MS
    },
    requestArguments: {
      path: generatePath('/patients/:patientId/temporary-images/qr', {patientId: patient.id}),
      method: 'GET'
    }
  });

  return <ResponsiveImage src={qrQuery.data.data.qr} alt="qr" />;
}
